import { OrganizationApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { CreateOrganizationDto, OrganizationPublicDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { useState } from 'react';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

const useHttpPostCreateOrganization = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [organization, setOrganization] = useState<OrganizationPublicDto>();
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const execCreate = (body: CreateOrganizationDto, callback: ICallback) => {
        const { exec, clearCache, abort } = organizationApi.createOrganization({
            body,
            onSuccess: res => {
                setOrganization(res.body);
                clearCache();
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: (error: AppError | string) => {
                if (typeof error === 'object' && isErrorCode(error, ErrorCodes.ORGANIZATION_NAME_EXISTS)) {
                    toastHandler.push(
                        'error',
                        t('organization.createOrganizationTitle'),
                        t('organization.createOrganizationMessage_Failed_Name_Already_Exists').replace('ORGANIZATION_NAME', body.name)
                    );
                } else if (typeof error === 'object' && isErrorCode(error, ErrorCodes.USER_ORGANIZATION_EXISTS)) {
                    toastHandler.push(
                        'error',
                        t('organization.createOrganizationTitle'),
                        t('organization.createOrganizationMessage_Failed_UserOrg_Already_Exists')
                    );
                } else {
                    const message =
                        typeof error === 'object'
                            ? getUserMessage(error, t('organization.createOrganizationMessage_Failed').replace('ORGANIZATION_NAME', body.name))
                            : t('organization.createOrganizationMessage_Failed').replace('ORGANIZATION_NAME', body.name);
                    toastHandler.push('error', t('organization.createOrganizationTitle'), message);
                }
            },
        });
        exec();
        return abort;
    };

    return {
        execCreate,
        organization,
    };
};

export default useHttpPostCreateOrganization;
